import React, { useRef, useEffect } from "react";
import Button from "carbon-react/lib/components/button";
import { Row, Column } from "carbon-react/lib/components/row";
import Loader from "carbon-react/lib/components/loader";

import "./DialogConfirmButtons.css";

const DialogConfirmButtons = ({
  appearBusy = false,
  confirmBtnEnabled = true,
  confirmBtnLabel = "Confirm",
  confirmBtnAutoFocus = false,
  onConfirmBtnBlur,
  onConfirm,
  cancelButtonLabel = "Cancel",
  cancelBtnAutoFocus = false,
  onCancel,
  omitCancelBtn = false,
  showBackBtn = false,
  backBtnEnabled = true,
  backBtnLabel = "Back",
  onBack,
}) => {
  const confirmRef = useRef(null);
  const cancelRef = useRef(null);

  useEffect(() => {
    if (confirmBtnAutoFocus) {
      if (isAValidFunc(confirmRef?.current?.focus)) {
        confirmRef.current.focus();
      }
    } else if (cancelBtnAutoFocus && isAValidFunc(cancelRef?.current?.focus)) {
      cancelRef.current.focus();
    }
  }, [appearBusy, confirmBtnAutoFocus, cancelBtnAutoFocus]);

  const isAValidFunc = (func) => {
    return func && typeof func === "function";
  };

  const onConfirmClicked = () => {
    if (isAValidFunc(onConfirm)) {
      onConfirm();
    }
  };

  const onConfirmBlur = () => {
    if (isAValidFunc(onConfirmBtnBlur)) {
      onConfirmBtnBlur();
    }
  };

  const onCancelClicked = () => {
    if (isAValidFunc(onCancel)) {
      onCancel();
    }
  };

  const onBackClicked = () => {
    if (isAValidFunc(onBack)) {
      onBack();
    }
  };

  const backButton = (
    <Column columnAlign="left">
      <Button
        id="dlg-confirm-btn-back"
        as="secondary"
        disabled={!backBtnEnabled || appearBusy}
        onClick={onBackClicked}
      >
        {backBtnLabel}
      </Button>
    </Column>
  );

  return (
    <Row className="dialog-confirm-button-row">
      {showBackBtn ? backButton : null}
      <Column columnAlign="right">
        <Button
          id="dlg-confirm-btn-confirm"
          forwardRef={(e) => {
            confirmRef.current = e;
          }}
          as="primary"
          disabled={!confirmBtnEnabled || appearBusy}
          onClick={onConfirmClicked}
          onBlur={onConfirmBlur}
        >
          {appearBusy ? (
            <Loader isInsideButton size="small" />
          ) : (
            confirmBtnLabel
          )}
        </Button>
        {omitCancelBtn ? null : (
          <Button
            id="dlg-confirm-btn-cancel"
            forwardRef={(e) => {
              cancelRef.current = e;
            }}
            as="secondary"
            disabled={appearBusy}
            onClick={onCancelClicked}
          >
            {cancelButtonLabel}
          </Button>
        )}
      </Column>
    </Row>
  );
};

export default DialogConfirmButtons;
